import {
  addDays,
  addMonths,
  addWeeks,
  addYears,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import { DayPickerBase } from 'react-day-picker';

export const dateRangeLogic = (
  value: string,
  rangeFromDate: Date | undefined,
  periodStartFrom: string | undefined,
  periodAmount: string | undefined,
  locale: DayPickerBase['locale'],
  weekStartsOn: DayPickerBase['weekStartsOn'],
) => {
  let dateFrom: Date;
  let period: Date;
  dateFrom = rangeFromDate || new Date();
  const amount = parseInt(periodAmount || '', 10) || 0;

  const localeOptions = {
    locale,
    weekStartsOn,
  };

  switch (value) {
    case 'day': {
      period = addDays(dateFrom, amount - 1);
      break;
    }
    case 'week': {
      if (periodStartFrom === 'next') {
        dateFrom = startOfWeek(addWeeks(new Date(), 1), localeOptions);
      } else if (periodStartFrom === 'last') {
        dateFrom = startOfWeek(addWeeks(new Date(), -amount), localeOptions);
      } else if (periodStartFrom === 'this') {
        dateFrom = startOfWeek(new Date(), localeOptions);
      } else if (periodStartFrom === 'past') {
        dateFrom = addWeeks(new Date(), -amount);
        period = new Date();
        break;
      }

      period = addDays(addWeeks(dateFrom, amount), -1);
      break;
    }
    case 'month': {
      if (periodStartFrom === 'next') {
        dateFrom = startOfMonth(addMonths(new Date(), 1));
      } else if (periodStartFrom === 'last') {
        dateFrom = startOfMonth(addMonths(new Date(), -amount));
      } else if (periodStartFrom === 'this') {
        dateFrom = startOfMonth(new Date());
      } else if (periodStartFrom === 'past') {
        dateFrom = addMonths(new Date(), -amount);
        period = new Date();
        break;
      }

      period = addDays(addMonths(dateFrom, amount), -1);
      break;
    }
    case 'year': {
      if (periodStartFrom === 'next') {
        dateFrom = startOfYear(addYears(new Date(), 1));
      } else if (periodStartFrom === 'last') {
        dateFrom = startOfYear(addYears(new Date(), -amount));
      } else if (periodStartFrom === 'this') {
        dateFrom = startOfYear(new Date());
      } else if (periodStartFrom === 'past') {
        dateFrom = addYears(new Date(), -amount);
        period = new Date();
        break;
      }

      period = addDays(addYears(dateFrom, amount), -1);
      break;
    }

    default: {
      period = new Date();
      break;
    }
  }
  return { dateFrom, period };
};

export const preselectOptionsLogic = (
  currentTarget: EventTarget & HTMLButtonElement,
  rangeFromDate: Date | undefined,
  locale: DayPickerBase['locale'],
  weekStartsOn: DayPickerBase['weekStartsOn'],
) => {
  const { periodStartFrom, periodAmount } = currentTarget.dataset;

  const { value } = currentTarget;

  const { dateFrom, period } = dateRangeLogic(
    value,
    rangeFromDate,
    periodStartFrom,
    periodAmount,
    locale,
    weekStartsOn,
  );

  return { dateFrom, period };
};
